export default __webpack_public_path__ + "static/media/README.842a9b54.md";